export default "__VITE_ASSET__aXPKaJNJ__"